import React, { useState } from 'react';
import { Button, Message } from 'semantic-ui-react';
import { useCookies } from 'react-cookie';
import { FormattedMessage, defineMessages, useIntl } from 'react-intl';
import { UniversalLink } from '@plone/volto/components';
import config from '@plone/volto/registry';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';
import { Link } from 'react-router-dom';

const messages = defineMessages({
  videoMessage: {
    id:
      "Your consent to the storage of data ('cookies') is required for the playback of this video on {website}. You can view and change your current data storage settings at any time under {privacy}.",
    defaultMessage:
      "Your consent to the storage of data ('cookies') is required for the playback of this video on {website}. You can view and change your current data storage settings at any time under {privacy}.",
  },

  mapMessage: {
    id:
      "Your consent to the storage of data ('cookies') is required to show this map from {website}. You can view and change your current data storage settings at any time under {privacy}.",
    defaultMessage:
      "Your consent to the storage of data ('cookies') is required to show this map from {website}. You can view and change your current data storage settings at any time under {privacy}.",
  },

  contentMessage: {
    id:
      "Your consent to the storage of data ('cookies') is required to show this content from {website}. You can view and change your current data storage settings at any time under {privacy}.",
    defaultMessage:
      "Your consent to the storage of data ('cookies') is required to show this content from {website}. You can view and change your current data storage settings at any time under {privacy}.",
  },

  videoButton: {
    id: 'Agree and show video',
    defaultMessage: 'Agree and show video',
  },

  audioMessage: {
    id:
      "Your consent to the storage of data ('cookies') is required to show this audio from {website}. You can view and change your current data storage settings at any time under {privacy}.",
    defaultMessage:
      "Your consent to the storage of data ('cookies') is required to show this audio from {website}. You can view and change your current data storage settings at any time under {privacy}.",
  },

  audioButton: {
    id: 'Agree and show audio',
    defaultMessage: 'Agree and show audio',
  },

  mapButton: {
    id: 'Agree and show map',
    defaultMessage: 'Agree and show map',
  },

  contentButton: {
    id: 'Agree and show content',
    defaultMessage: 'Agree and show content',
  },
});

const CookieConsentButtons = ({ module }) => {
  // eslint-disable-next-line no-unused-vars
  const [cookies, setCookie] = useCookies();
  const [animate, setAnimate] = useState(false);
  const intl = useIntl();
  const locale = intl.locale;

  let expiryDate = new Date();
  expiryDate.setMonth(expiryDate.getMonth() + 1);
  const options = { path: '/', expires: expiryDate };

  const services = {
    gmaps: {
      name: 'maps.google.com',
      website: 'https://maps.google.com',
    },
    osm: {
      name: 'OpenStreetMap',
      website: 'https://www.openstreetmap.org/',
    },
    youtube: {
      name: 'Youtube.com',
      website: 'https://youtube.com',
    },
    vimeo: {
      name: 'Vimeo.com',
      website: 'https://vimeo.com',
    },
    quickchannel: {
      name: 'Quickchannel.com',
      website: 'https://quickchannel.com',
    },
    twitter: {
      name: 'Twitter.com',
      website: 'https://twitter.com',
    },
    instagram: {
      name: 'Instagram.com',
      website: 'https://instagram.com',
    },
    facebook: {
      name: 'Facebook.com',
      website: 'https://facebook.com',
    },
    soundcloud: {
      name: 'Soundcloud.com',
      website: 'https://soundcloud.com',
    },
    podcaster: {
      name: 'Podcaster.de',
      website: 'https://podcaster.de',
    },
  };
  const service = services[module ?? ''];

  const links = {
    website: (
      <UniversalLink key="website" href={service?.website}>
        {service?.name}
      </UniversalLink>
    ),
    privacy: (
      <Link
        key="privacy"
        to={{
          pathname: flattenToAppURL(
            `${
              locale === 'de'
                ? config.settings.DSGVOBanner.privacy_url.de
                : config.settings.DSGVOBanner.privacy_url.en
            }#cookie-configure`,
          ),
        }}
      >
        <FormattedMessage id="privacy" defaultMessage="privacy" />
      </Link>
    ),
  };

  const messages_map = {
    video: {
      text: intl.formatMessage(messages.videoMessage, links),
      button: intl.formatMessage(messages.videoButton),
    },

    map: {
      text: intl.formatMessage(messages.mapMessage, links),
      button: intl.formatMessage(messages.mapButton),
    },

    audio: {
      text: intl.formatMessage(messages.audioMessage, links),
      button: intl.formatMessage(messages.audioButton),
    },

    content: {
      text: intl.formatMessage(messages.contentMessage, links),
      button: intl.formatMessage(messages.contentButton),
    },
  };

  return (
    <Message className={`cookie-consent-buttons ${animate ? 'animate' : ''}`}>
      <p>
        {module === 'gmaps' || module === 'osm'
          ? messages_map.map.text
          : module === 'soundcloud' || module === 'podcaster'
          ? messages_map.audio.text
          : module === 'youtube' ||
            module === 'vimeo' ||
            module === 'quickchannel'
          ? messages_map.video.text
          : messages_map.content.text}
      </p>
      <Button
        onClick={() => {
          setAnimate(true);
          setTimeout(function () {
            setCookie(`confirm_${module}`, 1, options);
          }, 250);
        }}
      >
        {module === 'gmaps' || module === 'osm'
          ? messages_map.map.button
          : module === 'soundcloud' || module === 'podcaster'
          ? messages_map.audio.button
          : module === 'youtube' ||
            module === 'vimeo' ||
            module === 'quickchannel'
          ? messages_map.video.button
          : messages_map.content.button}
      </Button>
    </Message>
  );
};

export default CookieConsentButtons;
